'use strict';
/* eslint global-require: 0 */

module.exports = require('./ReactSixteenAdapter'); //# sourceMappingURL=index.js.map